module.exports = __webpack_public_path__ + "img/fudai_tuijain_chanpin_btn.8cc46bb5.png";